import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export const ACCENTS = [
    { id: "teal", name: "Modern Teal", hsl: "193 100% 42%", hex: "#00B4D8" },
    { id: "gold", name: "Amber Gold", hsl: "42 100% 45%", hex: "#E69F00" },
    { id: "emerald", name: "Emerald", hsl: "162 95% 38%", hex: "#05B589" },
    { id: "coral", name: "Coral", hsl: "348 84% 56%", hex: "#E8355E" },
    { id: "indigo", name: "Indigo", hsl: "231 70% 55%", hex: "#4F5DD5" },
    { id: "violet", name: "Violet", hsl: "262 60% 58%", hex: "#8B5CF6" },
    { id: "crimson", name: "Crimson", hsl: "350 75% 50%", hex: "#DC2645" },
    { id: "tangerine", name: "Tangerine", hsl: "24 95% 53%", hex: "#F97316" },
    { id: "ocean", name: "Ocean Blue", hsl: "211 90% 50%", hex: "#1E7CE8" },
    { id: "forest", name: "Forest", hsl: "152 60% 34%", hex: "#2F9E6E" },
];

export const SURFACES = [
    { id: "porcelain", name: "Porcelain", hsl: "210 25% 93%", hex: "#E9EFF3" },
    { id: "sand", name: "Warm Sand", hsl: "40 25% 92%", hex: "#F1ECE3" },
    { id: "mist", name: "Sage Mist", hsl: "155 18% 92%", hex: "#E7F0EC" },
    { id: "slate", name: "Cool Slate", hsl: "220 20% 91%", hex: "#E3E9F2" },
    { id: "rose", name: "Rose Quartz", hsl: "350 30% 93%", hex: "#F3E9EA" },
];

const DEFAULTS = { accent: "teal", dark: false, density: "comfortable", surface: "porcelain" };

export function ThemeProvider({ children }) {
    const [prefs, setPrefs] = useState(() => {
        try {
            return { ...DEFAULTS, ...JSON.parse(localStorage.getItem("apptrack_prefs") || "{}") };
        } catch {
            return DEFAULTS;
        }
    });

    useEffect(() => {
        localStorage.setItem("apptrack_prefs", JSON.stringify(prefs));
        const accent = ACCENTS.find((a) => a.id === prefs.accent) || ACCENTS[0];
        const surface = SURFACES.find((s) => s.id === prefs.surface) || SURFACES[0];
        document.documentElement.style.setProperty("--brand", accent.hsl);
        document.documentElement.style.setProperty("--primary", accent.hsl);
        document.documentElement.style.setProperty("--ring", accent.hsl);
        document.documentElement.style.setProperty("--canvas", surface.hsl);
        document.documentElement.classList.toggle("dark", prefs.dark);
        document.documentElement.classList.toggle("density-compact", prefs.density === "compact");
        document.documentElement.style.fontSize = prefs.density === "compact" ? "14px" : "16px";
    }, [prefs]);

    const update = (patch) => setPrefs((p) => ({ ...p, ...patch }));

    return (
        <ThemeContext.Provider value={{ prefs, update }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
